module.exports = __webpack_public_path__ + "img/00028635_may_do_duong_huyet_tu_dong_mediusa_gm3300_1967_5fc9_large_62c3104a1c.5e1a2754.webp";